export enum PaymentMethodEnum {
    Systempay = "Systempay",
    Stripe = "Stripe",
    Bancontact = "Bancontact",
    Ideal = "Ideal",
    Adyen = "Adyen",
}